const styles = {
  imgStyles: {
    maxHeight: '100%',
    maxWidth: '100%',
    width: 'auto',
    height: 'auto',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto',
  },
  imgPreview: {
    cursor: 'pointer',
  },
};

export default styles;
